import React from 'react'

import { Card, Form } from 'antd'
import { useFormikContext } from 'formik'

import { ActionDetails } from '../ActionDetails'
import { ActionPermissions } from '../ActionPermissions'

import './styles.less'

export function ActionInfo() {
  const { handleSubmit } = useFormikContext()

  return (
    <div>
      <Form layout={'vertical'} onSubmit={handleSubmit}>
        <Card className="ant-card gx-card ant-card-bordered actionInfo">
          <ActionDetails />
          <ActionPermissions />
        </Card>
      </Form>
    </div>
  )
}
